import React, { useContext, useEffect, useRef, useState } from "react";
import DashboardHeader from "../../../common/DasnboardHeader/DashboardHeader";
import { Box, Tab, Tabs, TextField, Typography } from "@mui/material";
import { ticketsApi, ticketsTransition, ticketsType, visitorTypes } from "../../../services/TicketsServices";
import { useNavigate } from "react-router-dom";
import { DispatchContext, StateContext } from "../../../store";
import BarcodeReader from "react-barcode-reader";
import SetFilter from "./SetFilter";
import PropTypes from "prop-types";
import { styleBg } from "../../../common/Models/Validations";
import TicketsList from "./TicketsList";
import { SNACKBAR_OPEN } from "../../../reducers";
import AddVisitor from "./AddVisitor";
import DailySales from "../../../common/DasnboardHeader/DailySales";
import DailyReports from "./DailyReports";
import { debounce } from "lodash";
import TicketDetail from "./TicketDetail";
import { event } from "jquery";
import RefundPopup from "./RefundPopup";
import RefundsPanel from "./RefundsPanel";
import PageWrapper from "../../../common/PageWrapper/PageWrapper";
import AssessmentIcon from '@mui/icons-material/Assessment';         
import PeopleIcon from '@mui/icons-material/People';                 
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet'; 
import PaymentsIcon from '@mui/icons-material/Payments';             
import CreditCardIcon from '@mui/icons-material/CreditCard';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ pt: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function MainFrontDesk(props) {
  const navigate = useNavigate();
  const dispatch = useContext(DispatchContext);
  const user = JSON.parse(localStorage.getItem("user"));
  const museumId = user?.museums?.[0]?.id;
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [open, setOpen] = useState(false);
  const [visitorId, setVisitorId] = useState(null);
  const [page, setPage] = useState(() => {
    const savedPage = localStorage.getItem('receptionist_page');
    return savedPage ? parseInt(savedPage) : 1;
  });
  const [meta, setMeta] = useState({
    total_visitor: 0,
    total_amount: 0,
    total_cash: 0,
    total_electronic: 0,
    next_page: null,
    previous: null,
    total: 0
  });
  const [rowsPerPage, setRowsPerPage] = useState(() => {
    const savedRowsPerPage = localStorage.getItem('receptionist_rows_per_page');
    return savedRowsPerPage ? parseInt(savedRowsPerPage) : 10;
  });
  const [scannedBarcode, setScannedBarcode] = useState(null);
  const [barcode, setBarcode] = useState(null);
  const [tickets, setTickets] = useState({});
  const [filters, setFilters] = useState(() => {
    const savedFilters = localStorage.getItem('receptionist_filters');
    return savedFilters ? JSON.parse(savedFilters) : {};
  });
  const museumAssistant = user?.current_role?.name === "assistant";
  const museumReceptionist = user?.current_role?.name === "receptionist";
  const ticketId = tickets?.data?.[0]?.id;
  // Initialize tab state from localStorage
  const [value, setValue] = useState(() => {
    const savedTab = localStorage.getItem('receptionist_active_tab');
    return savedTab ? parseInt(savedTab) : 0;
  });
  const tabFilter = value === 0 ? "unused" : "used";
  const [refresh, setRefresh] = useState(true);
  const [dailyReports, setdailyReports] = useState({});
  const [selectedVisitorTypeId, setSelectedVisitorTypeId] = useState(null);
  const [isScanning, setIsScanning] = useState(false);
  const scanStartTime = useRef(null);
  const typingTimeout = useRef(null);
  const [refundOpen, setRefundOpen] = useState(false);
  const [refundTicketId, setRefundTicketId] = useState(null);
  const [ticketTypeOptions, setTicketTypeOptions] = useState([]);
  const [visitorTypeOptions, setVisitorTypeOptions] = useState([]);

  useEffect(() => {
    if (!museumId) {
      setTicketTypeOptions([]);
      return;
    }

    ticketsType("get", null, { page: 1, per_page: 200, status: "active", museum_id: museumId })
      .then((res) => {
        const list = res?.data || [];
        setTicketTypeOptions(list);
      })
      .catch(() => setTicketTypeOptions([]));
  }, [museumId]);

  useEffect(() => {
    visitorTypes("get", null, { page: 1, per_page: 200, status: "active" })
      .then((res) => {
        setVisitorTypeOptions(res?.data || []);
      })
      .catch(() => setVisitorTypeOptions([]));
  }, []);

  useEffect(() => {
    getTicketList();
  }, [filters, value, refresh, page, rowsPerPage]);

  // Save filters to localStorage when they change
  useEffect(() => {
    localStorage.setItem('receptionist_filters', JSON.stringify(filters));
  }, [filters]);

  const getTicketList = async () => {
    try {
      const ticketDisplay = value === 0 ? "unused" : "used";
      const visitorTypeId = Number(selectedVisitorTypeId);

      const apiParams = {
        search: barcode,
        ...filters,
        ticket_display: ticketDisplay,
        ...(Number.isFinite(visitorTypeId) && visitorTypeId > 0 ? { visitor_type_id: visitorTypeId } : {}),
        ...(museumId ? { museum_id: museumId } : {}),
        page: page,
        per_page: rowsPerPage,
      };
      
      
      const res = await ticketsApi("get", null, apiParams);
      setTickets(res?.data);
      setMeta(res?.meta);
    } catch (error) {
      console.error("Failed to fetch tickets:", error);
    }
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const editTicket = (id) => {
    setOpen(true);
    setVisitorId(id);
  };

  const handleClose = () => {
    setOpen(false);
    setVisitorId(null);
  };

  const handleChangePage = (event, newPage) => {
    const updatedPage = newPage + 1;
    setPage(updatedPage);
    localStorage.setItem('receptionist_page', updatedPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);
    setRowsPerPage(newRowsPerPage);
    localStorage.setItem('receptionist_rows_per_page', newRowsPerPage);
    setPage(1);
    localStorage.setItem('receptionist_page', 1);
  };

  const handleDetail = (ticketId) => {
    navigate(`/management/fd-dashboard/${ticketId}`);
  };
  const handleChange = (event, newValue) => {
    setValue(newValue);
    localStorage.setItem('receptionist_active_tab', newValue);
    setPage(1);
    localStorage.setItem('receptionist_page', 1);
  };

  const gettingTicketList = (boolean) => {
    setRefresh(boolean);
  };

  const markAsUsed = (ticketId) => {
    ticketsTransition("put", ticketId, { action: "use" })
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    setBarcode(inputValue);
    const now = Date.now();
    if (scanStartTime.current && now - scanStartTime.current < 50) {
      setIsScanning(true);
    } else {
      setIsScanning(false);
    }
    scanStartTime.current = now;

    setBarcode(inputValue);
    if (isScanning && inputValue.length === 12) {
      handleScan(inputValue);
    }
    if (typingTimeout.current) {
      clearTimeout(typingTimeout.current);
    }
    if (!isScanning) {
      typingTimeout.current = setTimeout(() => {
        handleSearch(inputValue);
      }, 51);
    }
  };

  const getTickets = async (limitedBarcode) => {
    await ticketsApi("get", null, { search: limitedBarcode, ...filters }).then((res) => {
      let id = res?.data?.[0]?.id;
      let ticketStatus = res?.data?.[0]?.state;
      if (ticketStatus === "completed") {
        ticketsTransition("put", id, { action: "use" }).then((response) => {
          dispatch({
            type: SNACKBAR_OPEN,
            payload: { isNotify: true, severity: "success", message: "Scanned Successfully" },
          });
          navigate(`/management/fd-dashboard/${id}`);
        });
      } else {
        dispatch({
          type: SNACKBAR_OPEN,
          payload: { isNotify: true, severity: "error", message: "Ticket Already Used" },
        });
        setValue(1);
        if (id) {
          navigate(`/management/fd-dashboard/${id}`);
        } else {
          dispatch({
            type: SNACKBAR_OPEN,
            payload: { isNotify: true, severity: "error", message: "Ticket Not Found" },
          });
        }
      }
    });
  };

  const handleScan = async (barcode) => {
    const limitedBarcode = barcode?.slice(0, -1);
    if (limitedBarcode.length === 11) {
      try {
        getTickets(limitedBarcode);
      } catch (err) {
        dispatch({
          type: SNACKBAR_OPEN,
          payload: { isNotify: true, severity: "error", message: "Ticket Not Found" },
        });
      }
    }
    setIsScanning(false);
  };

  const handleKeyDown = (e) => {
    if (isScanning && e.key === "Enter") {
      setBarcode("");
    }
  };

  const handleSearch = async (barcode) => {
    if (barcode) {
      try {
        const res = await ticketsApi("get", null, { search: barcode });

        if (res?.data?.length > 0) {
          setTickets(res.data);
          setMeta(res.meta);
          setFilteredTickets(res.data);
        } else {
          dispatch({
            type: SNACKBAR_OPEN,
            payload: {
              isNotify: true,
              severity: "error",
              message: "Tickets Not Found",
            },
          });
          setTickets([]);
          setFilteredTickets([]);
        }
      } catch (err) {
        dispatch({
          type: SNACKBAR_OPEN,
          payload: {
            isNotify: true,
            severity: "error",
            message: "Tickets Not Found",
          },
        });
      }
    }
  };

  const handleFilter = () => {
    getTicketList();
  };

  const handleClearFilters = () => {
    
    setFilters({});
    setSelectedVisitorTypeId(null);
    setBarcode(null);
    
    localStorage.removeItem('receptionist_filters');
    
    setRefresh(prev => !prev);
  };

  const handleRefundAction = (ticketId) => {
    setRefundTicketId(ticketId);
    setRefundOpen(true);
  };

  const handleRefundClose = () => {
    setRefundOpen(false);
    setRefundTicketId(null);
  };

  return (
    <PageWrapper>
      {user?.username !== "admin" && (user?.current_role?.name === "receptionist" || user?.current_role?.name === "assistant") && (
        <DashboardHeader title={"Reports"} total={meta?.total} IconName={AssessmentIcon} iconColor={'#ff9653'} desc={"Total Tickets"} handleOpen={handleOpen} btnName={"+ Add Visitor"} />
      )}
      <Box>
        <DailySales
          total={meta?.total}
          IconName={AssessmentIcon}
          desc={"Total Tickets Sold"}
          total_amount={meta?.total_amount}
          AmountIcon={AccountBalanceWalletIcon}
          note={"Total Amount"}
          total_visitor={meta?.total_visitor}
          VisitorIcon={PeopleIcon}
          text={"Total No. of Visitors"}
          total_cash={meta?.total_cash}
          CashIcon={PaymentsIcon}
          texts={"Total No. of Cash"}
          total_electronic={meta?.total_electronic}
          ElectronicIcon={CreditCardIcon}
          notes={"Total No. of Electronic"}
          iconColor={"#ff9653"}
          
        />
      </Box>
      <Box sx={{ display: "flex", alignItems: "stretch", gap: 3, mb: 2 }}>
        {user?.current_role?.name !== "receptionist" && (
          <Box sx={{ flex: 1 }}>
            <TextField
              label="Scan Barcode"
              variant="outlined"
              fullWidth
              value={barcode}
              focused={false}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              sx={{ height: "100%" }}
            />
          </Box>
        )}

        <Box sx={{ flex: 2 }}>
          <DailyReports
            setdailyReports={setdailyReports}
            fullWidth
            setSelectedVisitorTypeId={setSelectedVisitorTypeId}
            handleFilter={handleFilter}
            visitorTypeOptions={visitorTypeOptions}
            sx={{ height: "100%" }}
          />
        </Box>
      </Box>
      <BarcodeReader onScan={(barcode) => handleScan(barcode)} />
      <SetFilter 
          setFilters={setFilters} 
          visitorTypeOptions={visitorTypeOptions} 
          onClearFilters={handleClearFilters}
        />  
      <Tabs value={value} onChange={handleChange} aria-label="Ticket Tabs">
        <Tab label="New List" {...a11yProps(0)} sx={{ width: 210, ...styleBg(0, value) }} />
        <Tab label="Used Tickets" {...a11yProps(1)} sx={{ width: 210, ...styleBg(1, value) }} />
        <Tab label="Refunds" {...a11yProps(2)} sx={{ width: 210, ...styleBg(2, value) }} />
      </Tabs>
      <CustomTabPanel value={value} index={0}>
        <TicketsList
          editTicket={editTicket}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          handleDetail={handleDetail}
          tickets={tickets}
          page={page}
          meta={meta}
          rowsPerPage={rowsPerPage}
          visitorId={visitorId}
          open={open}
          refundAction={handleRefundAction}
          markAsUsed={markAsUsed}
          tabValue={value}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <TicketsList
          editTicket={editTicket}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          handleDetail={handleDetail}
          tickets={tickets}
          page={page}
          meta={meta}
          rowsPerPage={rowsPerPage}
          visitorId={visitorId}
          open={open}
          refundAction={handleRefundAction}
          markAsUsed={markAsUsed}
          tabValue={value}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <RefundsPanel />
      </CustomTabPanel>
      {open && (
        <AddVisitor
          open={open}
          handleAction={handleClose}
          visitorId={visitorId}
          gettingTicketList={gettingTicketList}
        />
      )}
      {refundOpen && (
        <RefundPopup
          open={refundOpen}
          handleClose={handleRefundClose}
          ticketId={refundTicketId}
        />
      )}
    </PageWrapper>
  );
}
